import React from 'react';
import { useSelector } from 'react-redux';
import DefaultLayout from '../../../layouts/default';
import { selectCanManageUsers } from '../../../features/users/usersSlice';
import { JobTitleProvider, useJobTitles } from './context/JobTitleContext';
import JobTitleHeader from './components/JobTitleHeader';
import JobTitleTable from './components/JobTitleTable';
import JobTitleFormDialog from './components/JobTitleFormDialog';
function Content() { const { form } = useJobTitles(); return <><JobTitleHeader /><JobTitleTable />{form && <JobTitleFormDialog />}</>; }
export default function JobTitlesPage() {
  const allowed = useSelector(selectCanManageUsers);
  return <DefaultLayout>{allowed ? <JobTitleProvider><Content /></JobTitleProvider> : <p role="alert" className="rounded-xl bg-white p-6 text-sm text-slate-600">Only administrators can manage job titles.</p>}</DefaultLayout>;
}
